import * as React from 'react'

import Slider from 'rc-slider'
import { HandlerStyles, RailStyles, SliderContainer, TrackStyles } from './Slider.styles'

export interface IRangeProps {
  min: number
  max: number
}

interface IProps {
  range: IRangeProps
  step: number
  value: IRangeProps
  onChange: (value: IRangeProps) => void
}

export default function RangeSlider(props: IProps) {
  const { range, step, value, onChange } = props

  return (
    <SliderContainer isRangeSlider>
      <Slider
        range
        min={range.min}
        max={range.max}
        value={[value.min, value.max]}
        onChange={handleOnChange}
        step={step}
        handleStyle={[HandlerStyles, HandlerStyles]}
        railStyle={RailStyles}
        trackStyle={[TrackStyles]}
      />
    </SliderContainer>
  )

  function handleOnChange(rangeChange: number | number[]) {
    if (Array.isArray(rangeChange)) {
      onChange({ min: rangeChange[0], max: rangeChange[1] })
    }
  }
}
